import { createFileRoute, Outlet, useNavigate, useMatches } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export const Route = createFileRoute('/_layout/_app/settings')({
  component: SettingsLayout,
  staticData: { title: 'Nastavitve' },
})

const TABS = [
  { key: 'company', path: '/settings/company' },
  { key: 'jobs', path: '/settings/jobs' },
  { key: 'documents', path: '/settings/documents' },
] as const

export function SettingsTabsNav() {
  const { t } = useTranslation(['settings'])
  const navigate = useNavigate()
  const matches = useMatches()

  const activeTab =
    TABS.find((tab) => matches.some((m) => m.fullPath.startsWith(tab.path)))?.key ?? 'documents'

  return (
    <nav className="flex gap-1">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          onClick={() => void navigate({ to: tab.path })}
          className={cn(
            'relative px-3 py-2 text-sm font-medium transition-colors cursor-pointer',
            activeTab === tab.key ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600',
          )}
        >
          {t(`settings:tabs.${tab.key}`)}
          {activeTab === tab.key && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-gray-900" />
          )}
        </button>
      ))}
    </nav>
  )
}

function SettingsLayout() {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="max-w-[900px] w-full mx-auto px-6 py-8 flex flex-col flex-1 min-h-0">
        <Outlet />
      </div>
    </div>
  )
}
